export default {
  validation: {
    "The login_id or password is not correct":
      "メールアドレスもしくはパスワードが正しくありません",
    "empty values not allowed": "必須項目です",
    "required field": "必須項目です",
    "min length is 8": "8 文字以上入力してください",
    "min value is 1": "1 以上入力してください",
    "value does not match regex": "不正な形式です",
    "ios_app_id or android_app_id is required field":
      "iOS App ID もしくは Android App ID のどちらかを入力してください",
    "red_user_id or twitter_user_id is required field":
      "Red 広告主 ID もしくは Twitter アカウント ID のどちらかを入力してください",
    "duplicated login_id": "登録済みのメールアドレスです",
    "does not exist": "選択してください",
    "red_dmp_id cannot be set when not AppsFlyer": "必須項目です",
    user: {
      password: {
        "invalid value": "パスワードが正しくありません",
      },
    },
  },
};
